module.exports = __webpack_public_path__ + "img/poster.bf589a8e.jpg";